import { Eye, X, ChevronDown } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { PREVIEW_ROLE_OPTIONS, previewRoleLabel } from "@/lib/previewRoles";

export function DemoPreviewBanner() {
  const { viewAsRole, setViewAsRole } = useAuth();
  const navigate = useNavigate();

  if (!viewAsRole) return null;

  const exitPreview = () => {
    setViewAsRole(null);
    navigate("/admin");
  };

  return (
    <div className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-2 bg-accent text-accent-foreground px-4 py-1.5 text-sm font-medium border-b border-border">
      <Eye className="h-4 w-4 shrink-0" />
      <span>Previewing as:</span>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="h-6 gap-1 px-2 text-xs font-semibold hover:bg-background/20">
            {previewRoleLabel(viewAsRole)}
            <ChevronDown className="h-3 w-3" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="w-56 bg-popover z-50">
          <DropdownMenuLabel>Switch preview</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {PREVIEW_ROLE_OPTIONS.map((opt) => (
            <DropdownMenuCheckboxItem
              key={opt.role}
              checked={viewAsRole === opt.role}
              onCheckedChange={(checked) => {
                if (checked) {
                  setViewAsRole(opt.role);
                  navigate(opt.home);
                } else {
                  exitPreview();
                }
              }}
            >
              {opt.label}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      <Button
        variant="ghost"
        size="sm"
        onClick={exitPreview}
        className="h-6 gap-1 px-2 text-xs hover:bg-background/20"
      >
        <X className="h-3 w-3" />
        Exit Preview
      </Button>
    </div>
  );
}
